<template>
  <div>
    <h2 class="bb-page-title">Services</h2>
    <div class="bb-services">
      <div class="bb-services-header">
        <ServiceInstitutions class="bb-services-header__item"/>
        <ServiceProject class="bb-services-header__item"/>
      </div>
      <VAT @setVat="setVat"/>
      <ServicesList @openForm="openForm = true" @openEditForm="editForm" :settings="settings" @changeTab="changeTab"/>
      <transition name="fade">
        <ModalWindow @close="closeForm" v-if="openForm || openEditForm">
          <ServiceForm :vat="settings.vat"
                       :defaultVal="openEditForm ? editItem : false"
                       :tab="activeTab"
                       @close="closeForm"/>
        </ModalWindow>
      </transition>
    </div>
  </div>
</template>

<script>
import ServiceCategories from '@/components/Settings/Services/ServiceCategories/ServiceCategories'
import ServiceInstitutions from '@/components/Settings/Services/ServiceInstitutions/ServiceInstitutions'
import ServiceProject from '@/components/Settings/Services/ServiceProject/ServiceProject'
import VAT from '@/components/Settings/Services/VAT/VAT'
import ServicesList from '@/components/Settings/Services/ServicesList/ServicesList'
import ServiceForm from '@/components/Settings/Services/ServiceForm/ServiceForm'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'

export default {
  name: 'SettingsServices',
  components: {
    ModalWindow,
    ServiceCategories,
    ServiceInstitutions,
    ServiceProject,
    VAT,
    ServicesList,
    ServiceForm
  },
  data: function () {
    return {
      settings: '',
      openForm: false,
      openEditForm: false,
      editItem: {},
      activeTab: 1
    }
  },
  methods: {
    changeTab (id) {
      this.activeTab = id
    },
    closeForm () {
      this.openForm = false
      this.openEditForm = false
    },
    editForm (item, index) {
      this.openEditForm = true
      this.editItem = item
      this.editItem.index = index
    },
    setVat (settings) {
      this.settings = settings
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";

  .bb-services {
    margin-top: 38px;

    .bb-services-header {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 68px;

      &__item {
        width: 50%;
        margin: 0 20px;
        flex-grow: 1;

        &:first-child {
          margin-left: -4px;
        }

        &:last-child {
          margin-right: -12px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Services/Services.vue